<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageBottom>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">         
              <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/bg_the-stadium.jpg" alt=""></transition></div>                                 
              
                <div class="page-content content">
                  <transition name="slide-fade" mode="out-in" appear>
                    <TitleContent h2="Home" h1="The Stadium" />
                  </transition>
                  <transition name="slide-fade" mode="out-in" appear>
                    <div class="text-content">                      
                      <p class='large yellow'>A premier entertainment destination that transcends sporting facilities</p>
                      <p>The Raiders’ commitment to excellence is illuminated throughout Allegiant Stadium. The venue offers the intimacy of an arena at the capacity of a stadium with state-of-the-art features that provide an elevated event experience. The team-venue relationship extends beyond a traditional partnership.</p>
                      <p class='yellow'>Las Vegas Raiders are Allegiant Stadium, functioning as one entity with  exponential resources.</p>
                    </div>                    
                  </transition>
                </div>
            </div>
        </div>
    </template>
    </PageBottom>    
  </div>
</template>

<script>
import PageBottom from "@/patterns/PageBottom.vue";
import TitleContent from "@/patterns/TitleContent.vue";
export default {
  name: "TheStadium",
  components: { PageBottom, TitleContent },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>